import { render } from "./loading.vue?vue&type=template&id=f813a69a&ts=true"
import script from "./loading.ts?vue&type=script&lang=ts&external"
export * from "./loading.ts?vue&type=script&lang=ts&external"

import "./loading.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__